<template>
  <section id="hero" flex flex-wrap flex-center>
    <div class="hero-container">
      <div class="information" flex flex-column>
        <div class="pill">🚀 Agencia de Desarrollo de Software</div>
        <h1>POTENCIA TU <br> <span class="gradient-text">PRESENCIA DIGITAL</span></h1>
        <p class="subtitle">Desarrollamos soluciones digitales a medida que transforman y escalan tu negocio hacia el futuro. Diseño, desarrollo y performance de alto nivel.</p>
        <div class="actions">
          <a href="#planes" class="btn-primary">Descubrir Planes</a>
          <a href="#servicios" class="btn-secondary">Nuestros Servicios</a>
        </div>
      </div>
      <div class="visuals">
        <div class="image-wrapper">
          <img src="/images/screen.jpg" alt="Digital Power Workspace" class="floating-img">
          <div class="glow-bg"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
#hero {
  width: 100%;
  min-height: calc(100vh - var(--header-height));
  background: var(--bg-color);
  position: relative;
  overflow: hidden;
}

#hero::before {
  content: '';
  position: absolute;
  top: -20%;
  left: -10%;
  width: 50%;
  height: 60%;
  background: radial-gradient(circle, var(--primary-glow) 0%, transparent 70%);
  z-index: 0;
}

.hero-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 2rem;
  z-index: 1;
}

.information {
  width: 50%;
  align-items: flex-start;
  text-align: left;
}

.pill {
  background: rgba(79, 70, 229, 0.1);
  color: var(--primary);
  padding: 0.5rem 1rem;
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.85rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 10px rgba(79, 70, 229, 0.05);
}

h1 {
  font-size: 4rem;
  line-height: 1.1;
  color: var(--text-main);
  margin-bottom: 1.5rem !important;
  letter-spacing: -1px;
}

.gradient-text {
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.subtitle {
  font-size: 1.1rem;
  color: var(--text-muted);
  line-height: 1.6;
  margin-bottom: 2.5rem !important;
  max-width: 90%;
}

.actions {
  display: flex;
  gap: 1rem;
}

.btn-primary, .btn-secondary {
  text-decoration: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-weight: 600;
  transition: all var(--duration);
  font-size: 1rem;
}

.btn-primary {
  background: var(--primary);
  color: white !important;
  box-shadow: 0 10px 20px var(--primary-glow);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 25px rgba(79, 70, 229, 0.5);
    background: var(--secondary);
  }
}

.btn-secondary {
  background: white;
  color: var(--text-main) !important;
  border: 1px solid rgba(0,0,0,0.1);

  &:hover {
    background: rgba(0,0,0,0.02);
    transform: translateY(-3px);
  }
}

.visuals {
  width: 45%;
  position: relative;
}

.image-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 4/3;
}

.floating-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  animation: float 6s ease-in-out infinite;
  position: relative;
  z-index: 2;
}

.glow-bg {
  position: absolute;
  top: 10%;
  left: 10%;
  width: 80%;
  height: 80%;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  filter: blur(50px);
  opacity: 0.3;
  z-index: 1;
  border-radius: 50%;
}

@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-15px); }
  100% { transform: translateY(0px); }
}

@media screen and (max-width: 900px) {
  .hero-container {
    flex-direction: column;
    text-align: center;
    padding: 3rem 1rem;
  }
  .information {
    width: 100%;
    align-items: center;
    margin-bottom: 3rem;
  }
  .subtitle { max-width: 100%; }
  h1 { font-size: 3rem; }
  .visuals { width: 90%; }
}

@media screen and (max-width: 500px) {
  h1 { font-size: 2.5rem; }
  .actions {
    flex-direction: column;
    width: 100%;
  }
  .btn-primary, .btn-secondary { width: 100%; text-align: center; }
}
</style>